import { styled } from "goober";
import { navEnterStyles } from "../hooks/useNavTransition";

export const PanelHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 12px;
  flex-shrink: 0;
`;

export const PanelHeaderNavigation = styled("div")`
  ${navEnterStyles}
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
`;

export const PanelHeaderActions = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  & > * {
    flex-shrink: 0;
  }
`;
